import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { trackEntityById } from 'projects/core/src/public-api';
import { Project } from '../../../../project-misc/data/project/project';
import { CabinetsService } from '../../../data/cabinets.service';

@Component({
  selector: 'app-cabinet-list',
  templateUrl: './cabinet-list.component.html',
  styleUrls: ['./cabinet-list.component.scss']
})
export class CabinetListComponent implements OnInit, OnChanges {
  @Input()
  project: Project

  @Input()
  cabinets: Cabinet[]

  @Input()
  booleanString: string;

  @Input()
  isMobile: boolean;

  @Input()
  hidingMode: boolean;

  @Input()
  clearHideConfirmations: boolean;

  @Output()
  scrollToFileEmitter = new EventEmitter<Cabinet>()

  @Output()
  toggleCabinetStatusEmitter = new EventEmitter<Cabinet>()

  @Output()
  deleteItemEmitter = new EventEmitter<number>()

  @Output()
  hideCabinetEmitter = new EventEmitter<Cabinet>()

  @Output()
  updateCabinetNotesEmitter = new EventEmitter<Cabinet>()

  trackEntityById = trackEntityById;

  cabinetsToHide = new Set<string>();
  expandedNotes = new Set<string>();

  constructor(
    private cabinetsService: CabinetsService
  ) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clearHideConfirmations && !changes.clearHideConfirmations.firstChange) {
      this.cabinetsToHide.clear();
    }
  }

  toggleCabinetStatus(cabinet: Cabinet) {
    this.toggleCabinetStatusEmitter.emit(cabinet)
  }

  scrollToFile(cabinet: Cabinet) {
    this.scrollToFileEmitter.emit(cabinet)
  }

  deleteCabinet(index: number) {
    this.deleteItemEmitter.emit(index)
  }

  hideCabinet(cabinet: Cabinet) {
    if (this.cabinetsToHide.has(cabinet.cabinetName)) {
      // Second click - confirm hiding
      this.hideCabinetEmitter.emit(cabinet);
      this.cabinetsToHide.delete(cabinet.cabinetName);
    } else {
      // First click - mark for hiding
      this.cabinetsToHide.add(cabinet.cabinetName);
    }
  }

  isCabinetMarkedForHiding(cabinet: Cabinet): boolean {
    return this.cabinetsToHide.has(cabinet.cabinetName);
  }

  toggleNotes(cabinet: Cabinet) {
    const key = cabinet.cabinetId?.toString() || cabinet.cabinetName;
    if (this.expandedNotes.has(key)) {
      this.expandedNotes.delete(key);
    } else {
      this.expandedNotes.add(key);
    }
  }

  isNotesExpanded(cabinet: Cabinet): boolean {
    const key = cabinet.cabinetId?.toString() || cabinet.cabinetName;
    return this.expandedNotes.has(key);
  }

  updateNotes(cabinet: Cabinet, notes: string) {
    const trimmedNotes = notes.trim().substring(0, 128);
    cabinet.notes = trimmedNotes;
    const cabinetToSave = new Cabinet();
    cabinetToSave.id = cabinet.id;
    cabinetToSave.notes = trimmedNotes;
    this.cabinetsService.saveCabinet(cabinetToSave).subscribe({
      next: (updatedCabinet) => {
        cabinet.notes = updatedCabinet.notes;
      },
      error: (error) => {
        console.error('Failed to save cabinet notes:', error);
      }
    });
  }

  shouldShowNotes(cabinet: Cabinet): boolean {
    return (cabinet.notes && cabinet.notes.trim().length > 0) || this.isNotesExpanded(cabinet);
  }

}
